<template>
	<div class="container">
		<!-- 限制选择一条且已有图像的情况下 -->
		<div v-if="limit == 1 && fileList[0] && fileList[0].url"
			 class="picture-box"
			 @click="visible = true">
			<el-image :src="fileList[0].url"
					  fit="cover"></el-image>
		</div>
		<!-- 限制选择一条且未有图像的情况下 -->
		<div v-if="limit == 1 && (!fileList[0] || !fileList[0].url)"
			 class="picture-add-box"
			 @click="visible = true">
			<i class="el-icon-plus"></i>
		</div>
		<div v-if="limit != 1"
			 class="picture-add-box"
			 @click="visible = true">
			<i class="el-icon-plus"></i>
		</div>
		<div v-if="limit != 1"
			 class="picture-box"
			 v-for="(item, index) in fileList"
			 :key="index">
			<el-image :src="item.url"
					  fit="cover"></el-image>
		</div>
		<el-dialog :visible.sync="visible"
				   fullscreen
				   append-to-body
				   :show-close="false"
				   :close-on-press-escape="false"
				   :close-on-click-modal="false">
			<!-- <div class="title">
				<h3>{{ title }} </h3>
			</div> -->
			<a-row>
				<a-col class="left"
					   :span="5">
					<div class="left-title flex justify-between">
						<span class="el-icon-folder-opened"
							  @click="loadRootData()">根目录</span>
						<span class="el-icon-folder-add"
							  @click="addDir()"></span>
					</div>
					<el-tree v-if="treeDoc"
							 :data="treeData"
							 node-key="key"
							 lazy
							 :expand-on-click-node="false"
							 :default-expand-all="false"
							 class="custom-tree-role"
							 :load="loadDocData"
                            :props="{
                                isLeaf: (data, node) => {
                                    return data.type != 'folder'
                                }
                            }"
							 @node-click="showRightData">
						<span class="custom-tree-node"
							  slot-scope="{ node, data }">
							<span v-if="data.type == 'folder'"
								  class="iconfont document"></span>
							<span>{{ data.title }}</span>
						</span>
					</el-tree>
					<el-tree v-else
							 :data="treeData"
							 node-key="key"
							 :expand-on-click-node="false"
							 :default-expand-all="false"
							 class="custom-tree-role"
							 @node-click="showRightData">
						<span class="custom-tree-node"
							  slot-scope="{ node, data }">
							<span v-if="data.type == 'folder'"
								  class="iconfont document"></span>
							<span>{{ data.title }}</span>
						</span>
					</el-tree>
				</a-col>
				<a-col :span="19">
					<p class="path-active flex justify-between"
					   v-if="selected.length">
						<span>{{ selected.length }} 个被选中</span>
						<span class="path-right">
							<i class="iconfont clear-f"
							   @click="selected = []"></i>
							<i class="iconfont delete"
							   @click="onRemoveFiles()"></i>
						</span>
					</p>
					<p class="path"
					   v-else>
						<el-breadcrumb separator="/">
							<el-breadcrumb-item>
								<span @click="loadRootData()">
									根目录
								</span>
							</el-breadcrumb-item>
							<el-breadcrumb-item v-for="(item, index) in history"
												:key="index">
								<span @click="onHistory(item, index)">
									{{ item.title }}
								</span>
							</el-breadcrumb-item>
						</el-breadcrumb>
						<a-progress v-if="percent != 0"
									:strokeWidth="3"
									:showInfo="false"
									:percent="percent"
									:stroke-color="{
                            '0%': '#108ee9',
                            '100%': '#87d068',
                        }" />
					</p>
					<div class="media-item">
						<el-upload :action="uploadUrl"
								   :data="params"
								   :on-progress="onUploadProgress"
								   :before-upload="beforeUpload"
								   :on-success="successUpload"
								   :show-file-list="false"
								   list-type="picture-card">
							<i class="el-icon-plus"></i>
						</el-upload>
					</div>
					<div class="media-item"
						 v-show="adding">
						<div class="media-item-body">
							<span class="iconfont document"></span>
						</div>
						<div class="label">
							<el-input ref="inputDir"
									  size="mini"
									  v-model="inputVal"
									  @blur="addDirSuccess()"></el-input>
						</div>
					</div>
                    <!-- 文件夹 -->
					<div v-for="(item, index) in list.dir"
						 :key="'dir-' + index"
						 class="media-item"
						 @dblclick="dbclickDoc(item)"
						 @mouseenter="onEnterDir(item, index)"
						 @mouseleave="onLeaveDir(item, index)">
						<div class="media-item-body"
							 @click="onFile(item, index)">
							<div v-show="item.isShow"
								 class="media-item-black">
								<div class="media-item-action">
									<a-icon class="small-icon"
											@click.stop="dbclickDoc(item)"
											type="search" />
								</div>
							</div>
							<span class="iconfont document"></span>
						</div>
						<div class="label"
							 v-if="updating == index">
							<el-input :id="'input-' + index"
									  size="mini"
									  v-model="inputVal"
									  @blur="fileUpdateName(item, index)"></el-input>
						</div>
						<div class="label"
							 v-else>
							{{ item.title }}
						</div>
					</div>
                    <div v-for="(item, index) in list.doc"
						 :key="'doc-' + index"
						 class="media-item"
						 @dblclick="dbclickDoc(item)"
						 @mouseenter="onEnterFile(item, index)"
						 @mouseleave="onLeaveFile(item, index)">
						<div class="media-item-body"
							 @click="onFile(item, index)">
							<div v-show="item.isShow"
								 class="media-item-black">
								<div class="media-item-action">
									<a-icon class="small-icon"
											@click.stop="onFileDownload(item, index)"
											type="download" />
									<a-icon class="small-icon"
											v-if="editAble"
											@click.stop="onFileEditName(item, index)"
											type="edit" />
								</div>
							</div>
							<el-image :src="item.url"
									  fit="cover"
									  lazy>
								<div slot="error"
									 class="image-slot-error">
									<i class="iconfont article doc-icon"></i>
								</div>
							</el-image>
							<a-icon class="check-icon"
									v-show="selected.indexOf(item) == -1 ? false : true"
									type="check" />
						</div>
						<div class="label"
							 v-if="updating == index">
							<el-input :id="'input-' + index"
									  size="mini"
									  v-model="inputVal"
									  @blur="fileUpdateName(item, index)"></el-input>
						</div>
						<div class="label"
							 v-else>
							{{ item.title }}
						</div>
					</div>
				</a-col>
			</a-row>
			<div class="bottom flex justify-center">
				<el-button @click="visible = false;">取消</el-button>
				<el-button @click="handleOk"
						   v-if="selected.length"
						   type="primary">
					选择
					<span v-if="selected.length">({{ selected.length }})</span>
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: {
		value: {},
		title: {
			default: function () {
				return '媒体库';
			}
		},
		treeDoc: { // 是否开启树状目录
			default: function () {
				return true;
			}
		},
		limit: { // 限制选择条数, 默认单选
			default: function () {
				return 1;
			}
		},
		deleteAble: { // 是否允许删除文件
			default: function () {
				return true;
			}
		},
		editAble: { // 是否允许编辑文件
			default: function () {
				return true;
			}
		}
	},
	data() {
		return {
			path: '',
			history: [],
			list: [],
			treeData: [],
			selected: [],
			updating: null,
			inputVal: '',
			visible: false,
			loading: false,
			adding: false,
			imageVisible: false,
			percent: 0,
			prefix: '',
			uploadUrl: '',
			fileList: [],
			params: {},
		}
	},
	methods: {
		handleOk() {
			if (this.limit == 1) {
				this.$emit('input', this.selected[0].url);
				this.visible = false;
			} else {
				this.$emit('input', this.selected.map(item => {
					return {
						url: item.url
					};
				}));
				this.visible = false;
			}
		},
		onUploadProgress(event, file, fileList) {
			this.percent = Number(file.percentage.toFixed(0));
		},
		beforeUpload(file) {
			let _self = this;
			_self.params.key = _self.path + file.name;
		},
		successUpload(res, file, fileList) {
			this.percent = 0;
			this.refresh();
		},
		onFile(file, index) {
			if (this.limit == 0) return;
			else if (file.type == 'folder') return;
			else if (this.selected.indexOf(file) != -1) this.selected.splice(this.selected.indexOf(file), 1);
			else if (this.limit == 1) {
				this.selected[0] = file;
				this.$forceUpdate();
			}
			else if (this.selected.length >= this.limit) return;
			else this.selected.push(file);
		},
		onEnterFile(item, index) {
			this.list.doc[index].isShow = true;
			this.$forceUpdate();
		},
        onEnterDir(item, index) {
			this.list.dir[index].isShow = true;
			this.$forceUpdate();
		},
		onLeaveFile(item, index) {
			this.list.doc[index].isShow = false;
			this.$forceUpdate();
		},
        onLeaveDir(item, index) {
			this.list.dir[index].isShow = false;
			this.$forceUpdate();
		},
		onRemoveFiles() {
			let _self = this;
			_self.$confirm('确定删除此项? 无法恢复', '', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				let uuids = [];
				_self.selected.forEach(item => {
					if (item.type != 'folder') uuids.push(item.key);
				});
				if (!uuids.length) return;
				await _self.$api.deleteUserMedia(uuids);
				await _self.refresh();
				next();
			}).catch(() => { });
		},
		onHistory(item, index) {
			if (index == (this.history.length - 1)) return;
			this.history.splice(index + 1, this.history.length - index + 1);
			this.dbclickDoc(item, true);
		},
		onFileDownload(item, index) {
			let link = document.createElement("a");
			link.download = '';
			link.target = 'view_window';
			link.href = item.url;
			link.click();
			link.remove();
		},
		onFileEditName(item, index) {
			this.inputVal = item.title;
			this.updating = index;
			this.$forceUpdate();
			setTimeout(() => {
				// _self.$refs.inputDir.focus();
			}, 1);
		},
		addDir() {
			let _self = this;
			_self.inputVal = '';
			_self.adding = true;
			_self.$forceUpdate();
			setTimeout(() => {
				_self.$refs.inputDir.focus();
			}, 1);
		},
		async addDirSuccess() {
			let _self = this;
			if (_self.inputVal == '') {
				_self.inputVal = '';
				_self.adding = false;
			} else {
				const res = await _self.$api.createUserMediaDir(_self.path + _self.inputVal);
				if (res.status == 'ok') {
					_self.inputVal = '';
					_self.adding = false;
				}
				this.refresh();
			}

		},
		async fileUpdateName(item, index) {
			let _self = this;
			if (item.title == _self.inputVal) return;
			const res = await _self.$api.updateUserMedia({
				from: _self.getFileOriginPath(item.key) + item.title,
				to: _self.getFileOriginPath(item.key) + _self.inputVal,
			});
			if (res.status == 'ok') {
				_self.list[index].title = _self.inputVal;
				_self.updating = null;
			} else {
				_self.inputVal = item.title;
			}
		},
		getFileOriginPath(path) {
			const index = path.lastIndexOf('/');
			return path.substring(0, index + 1);
		},
		async dbclickDoc(item, ignored) {
			if (this.loading) return;
			if (item.type != 'folder') return;
			this.loading = true;
			this.path = item.url;
			if (!ignored) this.history.push(item);
			const res = await this.$api.getUserUploadMedia(item.url);
			if (res.status == 'ok') {
				this.list = res.data;
				// if (!this.treeDoc) this.treeData = res.data.dir.concat(res.data.doc);
                this.treeData = res.data.dir.concat(res.data.doc);
			}
			this.loading = false;
		},
		async loadDocData(node, resolve) {
			this.path = node.data.url;
			const res = await this.$api.getUserUploadMedia(node.data.url);
			if (res.status == 'ok') {
				this.list = res.data;
				resolve(res.data.dir);
			}
		},
		async showRightData(node) {
			if (this.loading) return;
			if (node.type != 'folder') return;
			this.loading = true;
			this.path = node.url;
			if (node.title) this.history.push(node);
			const res = await this.$api.getUserUploadMedia(node.url);
			if (res.status == 'ok') {
				this.list = res.data;
				// if (!this.treeDoc) this.treeData = res.data.dir.concat(res.data.doc);
                this.treeData = res.data.dir.concat(res.data.doc);
			}
			this.loading = false;
		},
		async loadRootData() {
			this.path = '';
			this.history = [];
			const res = await this.$api.getUserUploadMedia(this.path);
			if (res.status == 'ok') {
				this.list = res.data;
                this.treeData = res.data.dir.concat(res.data.doc);
			}
		},
		async refresh() {
			const res = await this.$api.getUserUploadMedia(this.path);
			if (res.status == 'ok') {
				this.list = res.data;
				// if (!this.treeDoc) this.treeData = res.data.dir.concat(res.data.doc);
                this.treeData = res.data.dir.concat(res.data.doc);
			}
		},
		async getUploadParam() {
			let _self = this;
			const res = await _self.$api.getUploadParam('space');
			_self.path = res.data.prefix;
			_self.prefix = res.data.prefix;
			_self.uploadUrl = res.data.host;
			_self.params.policy = res.data.policy;
			_self.params.signature = res.data.signature;
			_self.params.OSSAccessKeyId = res.data.accessid;
		},
		init() {
			this.getUploadParam();
			this.loadRootData();
		},
	},
	mounted() {

	},
	created() {
		this.init();
		if (typeof this.value == 'string' && this.value) {
			this.fileList = [];
			this.fileList.push({
				url: this.value
			});
		} else {
			this.fileList = this.value;
		}

	},
	watch: {
		path(value) {
			// if (!value) return;
			// let array = value.split("/");
			// if (array[0] == '') array.shift();
			// if (array[array.length - 1] == '') array.pop();
			// this.history = array;
			// this.$forceUpdate();
		},
		history(value) {
			console.log(value);
		},
		list() {
			this.selected = [];
		},
		value(value) {
			if (typeof value == 'string' && value) {
				this.fileList = [];
				this.fileList.push({
					url: value
				});
			} else {
				this.fileList = value;
			}
		}
	}
}

</script>
<style lang="less" scoped>
.ant-tree-switcher-icon {
	font-size: 20px !important;
}

.container {
	overflow-y: scroll;
}

.picture-box {
	width: 130px;
	height: 130px;
	text-align: center;
	display: inline-block;
	margin: 12px;
	overflow: hidden;
	line-height: 130px;
	cursor: pointer;
	border-radius: 5px;
}

.picture-add-box {
	width: 130px;
	height: 130px;
	text-align: center;
	line-height: 130px;
	margin: 12px;
	display: inline-block;
	overflow: hidden;
	border: 1px dashed #d9d9d9;
	border-radius: 5px;
	cursor: pointer;

	&:hover {
		border: 1px dashed #409eff;
	}

	i {
		font-size: 15px;
	}
}

.title {
	margin: 10px 0;
	font-weight: 400;
	font-size: 1.5rem;
}

.ant-row {
	height: 80vh;
}

.bottom {
}

.left {
	overflow: hidden;

	.left-title {
		display: flex;
		padding: 16px;
		position: relative;
		font-size: 15.4px;
		min-height: 56px;
		align-items: center;
		font-weight: 500;
		span {
			font-weight: 400;
			cursor: pointer;
		}
	}
}

.path {
	display: flex;
	flex-flow: row;
	flex-wrap: wrap;
	min-height: 56px;
	align-items: center;
	padding: 0 8px 0 8px;
	border-radius: 5px 5px 0 0;

	.el-breadcrumb {
	}
}

.path-active {
	display: flex;
	flex-flow: row;
	flex-wrap: wrap;
	min-height: 56px;
	align-items: center;
	padding: 0 8px 0 8px;
	color: #fff;
	border-radius: 5px 5px 0 0;
	background-color: rgb(102, 177, 255);

	.path-right {
		font-size: 15px;

		i {
			cursor: pointer;
			margin-right: 15px;
		}
	}
}

.media-item {
	position: relative;
	display: inline-block;
	width: 155px;
	height: 185px;
	border-radius: 5px;
	overflow: hidden;
	margin: 6px;
	cursor: pointer;

	.media-item-body {
		width: 148px;
		height: 148px;
		border: #f2f2ff solid 1px;
		overflow: hidden;
		position: relative;

		.check-icon {
			z-index: 3;
			position: absolute;
			color: rgb(45, 120, 233);
			right: 7px;
			bottom: 5px;
			font-size: 20px;
			width: 30px;
			height: 30px;
			line-height: 35px;
			border-radius: 50%;
			background: #f7f7f7;
			align-items: center;
		}
		.media-item-black {
			z-index: 2;
			width: 100%;
			height: 100%;
			position: absolute;
			background-color: rgba(0, 0, 0, 0.3);

			.media-item-action {
				top: 0;
				right: 0;
				color: #fff;
				margin: 4px;
				position: absolute;

				i {
					width: 18px;
					text-align: center;
					height: 18px;
					line-height: 18px;
					border-radius: 50%;
					background-color: rgb(139, 138, 138);
					font-size: 12px;
				}
			}
		}

		.el-image {
			z-index: 1;
			width: 100%;
			height: 100%;
		}
	}
	.label {
		width: 100%;
		font-size: 0.85rem;
		color: rgba(0, 0, 0, 0.54);
		position: absolute;
		bottom: 0;
		text-align: center;
		word-break: keep-all;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.document {
		font-size: 50px;
		width: 50px;
		height: 50px;
		line-height: 50px;
		top: calc(50% - 25px);
		left: calc(50% - 25px);
		color: #757575;
		position: absolute;
	}

	.doc-icon {
		font-size: 38px;
		width: 50px;
		height: 50px;
		line-height: 50px;
		top: calc(50% - 22px);
		left: calc(50% - 25px);
		color: #757575;
		position: absolute;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/media.vue